import PropTypes from 'prop-types';
import React from 'react';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';
import { ButtonGroup, Button } from 'react-bootstrap';
import { displayBuyerBidState, displayBidderBidState } from '../../../core/api';
import { findById } from '../../../core/utils';
import { fullDate, monthNameFormatDate } from '../../../core/date';
import BidDetailModal from './BidDetailModal';
import BidUpdateModal from './BidUpdateModal';
import UpdatedBidsModal from './UpdatedBidsModal';
import HideButton from './HideButton';
import { Modal } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton, SearchField } from 'react-bootstrap-table';

function displayBidState(buyerState, bidderState) {
  if (['ST'].includes(buyerState)) {
    return `${displayBuyerBidState(buyerState, bidderState)} (${displayBidderBidState(
      buyerState,
      bidderState
    )})`;
  }
  return displayBuyerBidState(buyerState, bidderState);
}

  function getRandomColor() {
      var letters = 'BCDEF'.split('');
      var color = '#';
      for (var i = 0; i < 6; i++ ) {
          color += letters[Math.floor(Math.random() * letters.length)];
      }
      return color;
  }

class LocationBidsetsTable extends React.Component {
  constructor(props) {
    super(props);
    if (props.detail) {
      this.state = {
        showBid: true,
        showSend: true,
        bid: props.detail,
        showUpdateModal:false,
        answersData:false,
        location:this.props.currentLocation,
        bidbidsDetails:[],
        isLoading:false,
      };
    } else {
      this.state = {
        showBid: false,
        showUpdateModal:false,
        answersData:false,
        bidbidsDetails:[],
        isLoading:false,
      };
    }
    this.showBid = this.showBid.bind(this);
    this.closeBid = this.closeBid.bind(this);
    this.showUpdatePopup = this.showUpdatePopup.bind(this);
    this.closeUpdatePopup = this.closeUpdatePopup.bind(this);
    this.renderShowsTotal = this.renderShowsTotal.bind(this);
  }

  closeBid() {
    this.setState({
      showBid: false,
    });
  }

  showUpdatePopup() {
    this.setState({
      showUpdateModal:true
    });
  }

  closeUpdatePopup() {
     this.setState({
      showUpdateModal:false
    });
  }

  showBid(e) {  
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      this.props.requestBidDetails(id,(response)=>{
        if(response){
          this.setState({
            bidbidsDetails:response.results,
            isLoading:false,
          })
        }
      })
      let answersval=[];
      this.props.requestAnswers(id,(response) => {
      if(this.props.answers){
        this.props.answers.answers.forEach((answer) => {
          answersval.push({
            question:answer.question,
            answer:answer.answer,
          })
        })
      } else{
        console.log("data is not avaiable")
      }
    });
      this.setState({
        bid: id,
        showBid: true,
        showSend: true,
        answersData: answersval,
      });
    }
  }

  renderShowsTotal(start, to, total) {
    if(total == 0) {
      return(
        <span></span>
      )
    }
    return (
      <p id="bidsetTableListingPerPage">
       Listings Per Page &nbsp;&nbsp;(From { start } to { to }, Total is { total })
      </p>
    );
  }

  findBid(id) {
    const idx = this.props.bids.findIndex(findById, id);
    if (idx === -1) {
      console.log('unable to find bid...', id);
      return {};
    }
    return this.props.bids[idx];
  }

 trStyle = (row, rowIndex) => {
      return { backgroundColor: typeof(row) != 'undefined' ? row.bgcolor : ''};
  }
 btncolumn = (row,rowIndex) =>{
  return(
      <ButtonGroup className="manage-bids-btnGroup">
        <Button bsStyle="default" data-item={row} onClick={this.showBid}>
          <i className="fa fa-search fa-lg" /> View Bid
        </Button>
        {!this.props.isTourManager && (
          <HideButton bid={this.findBid(row)} editBid={this.props.editBid} />
        )}
        {rowIndex.noteCount > 0 && rowIndex.stateAfterResponded && (
          <span className="notecount fa-2x has-badge" data-count={rowIndex.noteCount}>  
            <i className="fa fa-sticky-note fa-sm"></i>
          </span>
        )}
      </ButtonGroup>
      )
 }
 dateDisplay = (row, rowIndex) => {
    return (
      <span> {monthNameFormatDate(row)} </span>
      )
  }

 formatStatusDisplay = (row, rowIndex) => {
    if(row == 'Stay Cancelled') {
    return (
      <span className="stay-cancelled-text">{row}</span>
      )
    } else if(row == 'Stay Updated') {
    return (
      <span onClick={this.showUpdatePopup} className="stay-updated-text" title="Click here to see list of bids for Updated stay">{row}</span>
      )
    } else {

      return (
      <span>{row}</span>
      )
    }
  }

 formatHotelDisplay = (row, rowIndex) => {  
    return (
    <span title={row}> {row} </span>
    )
 }

 createCustomSearchField = (props) => {
      return (
        <SearchField
            className='form-control'
            placeholder='Filter'/>
      );
 }

  render() {
      
    const options = {
      searchField: this.createCustomSearchField ,   // right or left
      sortIndicator: false ,
      defaultSortName: 'start',
      defaultSortOrder: 'asc',
      paginationShowsTotal: this.renderShowsTotal,
      paginationPosition: 'top',
      sizePerPage:30
    };
    
    const parentIds =[];
    const bids = [];
    this.props.bids.forEach(bid => {
      // Filter bids with filter or hardcoded filter for tour manager
      let parent = parentIds.includes(bid.bidset.event.parent);
      if(parent==false){
        parentIds.push(bid.bidset.event.parent)
      }
      if (this.props.filter[bid.buyer_state]) {
        return;
      }
      if (this.props.filter[bid.bidset.event.group_name]) {
        return;
      }

      // Don't show hidden bids to Tour Manager
      if (this.props.isTourManager && !bid.share) {
        return;
      }
      let location;
      if (bid.hotel.city == null){
        location = `${bid.hotel.state}, ${bid.hotel.country}`;
      };
      if (bid.hotel.state == null){
        location = `${bid.hotel.city}, ${bid.hotel.country}`;
      };
      if (bid.hotel.city == null && bid.hotel.state == null){
        location = `${bid.hotel.country}`;
      };
      if (bid.hotel.city == null && bid.hotel.state == null && bid.hotel.country == null){
        location = '';
      };
      if (bid.hotel.city != null && bid.hotel.state != null && bid.hotel.country != null){
        if (bid.hotel.city === bid.hotel.state){
          location = `${bid.hotel.city}, ${bid.hotel.country}`;
        } else{
          if (bid.hotel.state === bid.hotel.country){
            location = `${bid.hotel.city}, ${bid.hotel.country}`;
          }else{
            location = `${bid.hotel.city}, ${bid.hotel.state}, ${bid.hotel.country}`;
          }
         }
      };
      const displayState = displayBidState(bid.buyer_state, bid.bidder_state);
      const stateAfterResponded = ['IN', 'PD', 'RE'].includes(bid.bidder_state);
      const newbid = {
        id: bid.id,
        name: bid.hotel.name,
        group: bid.bidset.event.group_name,
        location,
        distance: parseFloat(bid.distance_to_venue * 0.621371).toFixed(2),
        start: bid.bidset.event.start,
        end: bid.bidset.event.end,
        state: displayState,
        bgcolor: bid.background_color ? bid.background_color : '',        
        noteCount: (typeof(bid.notes) != 'undefined' ? (bid.notes).length : 0),       
        stateAfterResponded: stateAfterResponded,
        parent: bid.bidset.event.parent,
      };
      if (bid.suite_rate) {
        newbid.suite = bid.suite_rate;
      }
      if (bid.king_rate) {
        newbid.king = bid.king_rate;
      }
      if (bid.queen_rate) {
        newbid.queen = bid.queen_rate;
      }
      bids.push(newbid);
    });
    const bidData = [];
    const bidsFilter = (id)=> {
      bids.forEach((bid)=>{
        if(bid.parent==id){
          bidData.push(bid);
        }
      });
    }
    return (
       <div id="manageBidsList">
       {parentIds.map((id) =>(
        <div key={id} >
          {this.props.parent==id?(
            <div>
            {bidsFilter(id)}
            <BootstrapTable
              containerStyle = {{ marginTop: '10px' }}
              data = {bidData}
              trStyle = { this.trStyle }
              options = { options }
              striped
              pagination
              search = { true }
            >
              <TableHeaderColumn dataField="name" dataSort={ true } isKey={true} width="94" headerAlign="center" dataAlign="center"  dataFormat={this.formatHotelDisplay}>Hotel</TableHeaderColumn>
              <TableHeaderColumn dataField="group" dataSort={ true } width="80" headerAlign="center" dataAlign="center"  >Group</TableHeaderColumn>
              <TableHeaderColumn dataField="location" dataSort={ true } width="90" headerAlign="center" dataAlign="center"  >Location</TableHeaderColumn>
              <TableHeaderColumn dataField="distance" dataSort={ true } width="80" headerAlign="center" dataAlign="center"  >Distance</TableHeaderColumn>
              <TableHeaderColumn dataField="start" dataSort={ true } width="90" headerAlign="center" dataAlign="center" dataFormat={this.dateDisplay}>Check In</TableHeaderColumn>
              <TableHeaderColumn dataField="end" dataSort={ true } width="90" headerAlign="center" dataAlign="center" dataFormat={this.dateDisplay}>Check Out</TableHeaderColumn>
              <TableHeaderColumn dataField="state" dataSort={ true } width="110" headerAlign="center" dataAlign="center" dataFormat={this.formatStatusDisplay}>Status</TableHeaderColumn>
              <TableHeaderColumn dataField="id"  width="200" headerAlign="center" dataAlign="right" dataFormat={this.btncolumn}></TableHeaderColumn>
            </BootstrapTable>
            </div>
          ):('')}
          </div>
       ))}
        {this.state.showBid && (
          <BidDetailModal
            bid={this.findBid(this.state.bid)}
            bids={bids}
            show={this.state.showBid}
            showSend={this.state.showSend}
            onClose={this.closeBid}
            addBidNote={this.props.addBidNote}
            editBid={this.props.editBid}
            sendBid={this.props.sendBid}
            sendHotelBidRequests={this.props.sendHotelBidRequests}
            removeBid={this.props.removeBid}
            isTourManager={this.props.isTourManager}
            readOnly={this.props.readOnly}
            user={this.props.user}
            tourData={this.props.tourData}
            editMember={this.props.editMember}
            bidbidsDetails={this.state.bidbidsDetails}
            isLoading={this.state.isLoading}
            requestBidDetails={this.props.requestBidDetails}
            answers={this.state.answersData}
            editGroup={this.props.editGroup}
            ChangeBidDetail={this.props.ChangeBidDetail}
            changeBidDateDetail={this.props.changeBidDateDetail}
            editGroupEventOnManageBid={this.props.editGroupEventOnManageBid}
            dispatchRemoveMemberFromManageBid={this.props.dispatchRemoveMemberFromManageBid}
            changeDateRoomType={this.props.changeDateRoomType}
            addParticipantManageBid={this.props.addParticipantManageBid}
          />
        )}
        {this.props.showUpdate && (
          <BidUpdateModal
            bids={bids}
            show={this.props.showUpdate}
            onClose={this.props.closeUpdate}
            sendBidUpdate={this.props.sendBidUpdate}
            user={this.props.user}
          />
        )}
        {this.state.showUpdateModal && (
          <UpdatedBidsModal
           showUpdate={this.state.showUpdateModal}
           closeUpdate={this.closeUpdatePopup}
           bids={bids}
           updateReOpenBid={this.props.updateReOpenBid}
           requestBidsets={this.props.requestBidsets}
           tourData={this.props.tourData}
          />

          )}
      </div>
    );
  }
}

LocationBidsetsTable.propTypes = {
  bids: PropTypes.arrayOf(PropTypes.object).isRequired,
  isTourManager: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  detail: PropTypes.string,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  showUpdate: PropTypes.bool.isRequired,
  closeUpdate: PropTypes.func.isRequired,
  sendBidUpdate: PropTypes.func.isRequired,
  requestAnswers: PropTypes.func.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,

};

LocationBidsetsTable.defaultProps = {
  bids: [],
  detail: null,
};
export default LocationBidsetsTable;



// WEBPACK FOOTER //
// src/routes/tours/components/LocationBidsetsTable.js